module.exports = __webpack_public_path__ + "static/media/AverageIcon.4691345b.svg";